module.exports = __webpack_public_path__ + "assets/media/3.6c53c882.wav";